module.exports = __webpack_public_path__ + "static/media/ApplicationFeeStatus.3d916f6f.svg";